<template>
    <v-container class="pt-0">
        <v-row>
            <v-col cols="12" class="pa-0">
                <v-stepper v-model="getContractErrors.step" class="elevation-0">
                    <template>
                        <v-stepper-header class="elevation-0 stepperHeader">
                            <v-divider></v-divider>
                            <v-stepper-step
                                :rules="[
                                    () => getContractErrors.stepOne.validation,
                                ]"
                                editable
                                step="1"
                                >{{ $t('contracts:basicInfo') }}</v-stepper-step
                            >
                            <v-divider></v-divider>
                        </v-stepper-header>
                        <v-stepper-items>
                            <v-stepper-content class="pb-0 pt-4" step="1">
                                <v-row>
                                    <v-col cols="12" md="12" class="pt-0">
                                        <Separator
                                            :text="$t('contracts:basicInfo')"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="4"
                                        ><v-text-field
                                            v-model="getContractModal.number"
                                            :error-messages="
                                                getContractErrors.stepOne.fields
                                                    .number
                                            "
                                            :label="`${$t(
                                                'contracts:number'
                                            )}*`"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-menu
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template
                                                v-slot:activator="{
                                                    on,
                                                    attrs,
                                                }"
                                            >
                                                <v-text-field
                                                    v-model="
                                                        getContractModal.signDate
                                                    "
                                                    clearable
                                                    @click:clear="
                                                        getContractModal.signDate = null
                                                    "
                                                    :label="`${$t(
                                                        'contracts:signDate'
                                                    )}*`"
                                                    prepend-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    :error-messages="
                                                        getContractErrors
                                                            .stepOne.fields
                                                            .signDate
                                                    "
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="
                                                    getContractModal.signDate
                                                "
                                                @input="startDate = false"
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-menu
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template
                                                v-slot:activator="{
                                                    on,
                                                    attrs,
                                                }"
                                            >
                                                <v-text-field
                                                    v-model="
                                                        getContractModal.expirationDate
                                                    "
                                                    clearable
                                                    @click:clear="
                                                        getContractModal.expirationDate = null
                                                    "
                                                    :label="`${$t(
                                                        'contracts:expirationDate'
                                                    )}`"
                                                    prepend-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="
                                                    getContractModal.expirationDate
                                                "
                                                @input="startDate = false"
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6"
                                        ><v-text-field
                                            v-model="getContractModal.title"
                                            :error-messages="
                                                getContractErrors.stepOne.fields
                                                    .title
                                            "
                                            :label="`${$t('contracts:title')}*`"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-select
                                            style="width: 60%; float: right;"
                                            v-model="
                                                getContractModal.contractType
                                            "
                                            :items="
                                                getRegistryDictionaries.contractType
                                                    ? getRegistryDictionaries.contractType
                                                    : []
                                            "
                                            :label="`${$t(
                                                'contracts:contractType'
                                            )}*`"
                                            return-object
                                            item-value="field"
                                            :error-messages="
                                                getContractErrors.stepOne.fields
                                                    .contractType
                                            "
                                            ><template v-slot:item="data">
                                                <span
                                                    v-if="
                                                        data.item
                                                            .backgroundColor
                                                    "
                                                >
                                                    <v-chip
                                                        class="mx-2"
                                                        :color="
                                                            data.item
                                                                .backgroundColor
                                                        "
                                                        small
                                                        label
                                                        :text-color="
                                                            data.item.textColor
                                                                ? data.item
                                                                      .textColor
                                                                : '#4d4d4d'
                                                        "
                                                    >
                                                        {{ data.item.field }}
                                                    </v-chip>
                                                </span>
                                                <span
                                                    class="truncate-list"
                                                    v-else
                                                >
                                                    {{ data.item.field }}
                                                </span>
                                            </template>
                                            <template v-slot:selection="data">
                                                <span
                                                    v-if="
                                                        data.item
                                                            .backgroundColor
                                                    "
                                                >
                                                    <v-chip
                                                        class="mx-2"
                                                        :color="
                                                            data.item
                                                                .backgroundColor
                                                        "
                                                        small
                                                        label
                                                        :text-color="
                                                            data.item.textColor
                                                                ? data.item
                                                                      .textColor
                                                                : '#4d4d4d'
                                                        "
                                                    >
                                                        {{ data.item.field }}
                                                    </v-chip>
                                                </span>
                                                <span
                                                    class="truncate-list"
                                                    v-else
                                                >
                                                    {{ data.item.field }}
                                                </span>
                                            </template>
                                        </v-select>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6">
                                        <v-combobox
                                            v-model="
                                                getContractModal.contractor
                                            "
                                            :label="`${$t(
                                                'contracts:contractor'
                                            )}*`"
                                            hint="Zacznij pisać..."
                                            @keyup="
                                                setContacts($event.target.value)
                                            "
                                            @input="assignID()"
                                            :hide-no-data="hideContacts"
                                            :items="getContactsInput.items"
                                            item-text="name"
                                            item-value="_id"
                                            return-object
                                            :error-messages="
                                                getContractErrors.stepOne.fields
                                                    .contractor
                                            "
                                        >
                                        </v-combobox>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-combobox
                                            :label="`${$t(
                                                'contracts:representative'
                                            )}`"
                                            v-model="
                                                getContractModal.representative
                                            "
                                            @keyup="
                                                setRepresentatives(
                                                    $event.target.value
                                                )
                                            "
                                            :item-text="text"
                                            return-object
                                            append-outer-icon="mdi-account-plus"
                                            item-value="_id"
                                            :items="
                                                getRepresentativeInput.items
                                            "
                                            ><template
                                                slot="selection"
                                                slot-scope="data"
                                            >
                                                {{ data.item.name }}
                                                {{ data.item.lastname }}
                                            </template>
                                            <template
                                                slot="item"
                                                slot-scope="data"
                                            >
                                                {{ data.item.name }}
                                                {{ data.item.lastname }}
                                            </template>
                                            <template slot="append-outer">
                                                <v-menu
                                                    :close-on-content-click="
                                                        false
                                                    "
                                                    :close-on-click="false"
                                                    @input="
                                                        v =>
                                                            v ||
                                                            clearMiniModal()
                                                    "
                                                    max-width="300"
                                                    min-width="300"
                                                    origin="center"
                                                    v-model="showMenu"
                                                >
                                                    <template
                                                        v-slot:activator="{
                                                            on: menu,
                                                        }"
                                                    >
                                                        <v-tooltip top>
                                                            <template
                                                                v-slot:activator="{
                                                                    on: tooltip,
                                                                }"
                                                            >
                                                                <v-btn
                                                                    small
                                                                    icon
                                                                    :disabled="
                                                                        getContactsInput
                                                                            .items
                                                                            .length >
                                                                        0
                                                                            ? false
                                                                            : true
                                                                    "
                                                                >
                                                                    <v-icon
                                                                        v-on="{
                                                                            ...menu,
                                                                            ...tooltip,
                                                                        }"
                                                                        @click="
                                                                            showMenu = true
                                                                        "
                                                                        >mdi-plus</v-icon
                                                                    >
                                                                </v-btn>
                                                            </template>
                                                            <span>{{
                                                                $t(
                                                                    'contracts:addRepresentative'
                                                                )
                                                            }}</span>
                                                        </v-tooltip>
                                                    </template>
                                                    <v-card>
                                                        <v-container>
                                                            <v-row>
                                                                <v-col
                                                                    cols="12"
                                                                >
                                                                    <h3>
                                                                        {{
                                                                            `${$t(
                                                                                'contracts:additionRepresentative'
                                                                            )}`
                                                                        }}
                                                                    </h3>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row>
                                                                <v-col
                                                                    cols="12"
                                                                >
                                                                    <v-text-field
                                                                        dense
                                                                        v-model="
                                                                            getRepresentativeModal.name
                                                                        "
                                                                        :label="`${$t(
                                                                            'contracts:representativeName'
                                                                        )}`"
                                                                    >
                                                                    </v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row>
                                                                <v-col
                                                                    cols="12"
                                                                >
                                                                    <v-text-field
                                                                        dense
                                                                        v-model="
                                                                            getRepresentativeModal.lastname
                                                                        "
                                                                        :label="`${$t(
                                                                            'contracts:representativeLastname'
                                                                        )}`"
                                                                    >
                                                                    </v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row>
                                                                <v-col
                                                                    cols="12"
                                                                >
                                                                    <v-text-field
                                                                        dense
                                                                        v-model="
                                                                            getRepresentativeModal.email
                                                                        "
                                                                        :label="`${$t(
                                                                            'contracts:representativeEmail'
                                                                        )}`"
                                                                    >
                                                                    </v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row>
                                                                <v-col
                                                                    cols="12"
                                                                >
                                                                    <v-text-field
                                                                        dense
                                                                        v-model="
                                                                            getRepresentativeModal.phoneNumber
                                                                        "
                                                                        :label="`${$t(
                                                                            'contracts:representativePhoneNumber'
                                                                        )}`"
                                                                    >
                                                                    </v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row>
                                                                <v-col
                                                                    md="12"
                                                                    class="py-0 my-0 d-flex justify-end"
                                                                >
                                                                    <v-btn
                                                                        class="buttons buttons--cancel mr-2"
                                                                        @click="
                                                                            clearMiniModal()
                                                                        "
                                                                        >{{
                                                                            $t(
                                                                                'cancel'
                                                                            )
                                                                        }}</v-btn
                                                                    >
                                                                    <v-btn
                                                                        class="buttons buttons--add"
                                                                        :disabled="
                                                                            disabled
                                                                        "
                                                                        @click="
                                                                            additionRepresentative()
                                                                        "
                                                                        >{{
                                                                            $t(
                                                                                'add'
                                                                            )
                                                                        }}</v-btn
                                                                    >
                                                                </v-col>
                                                            </v-row>
                                                        </v-container>
                                                    </v-card>
                                                </v-menu>
                                            </template>
                                        </v-combobox>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <v-textarea
                                            :label="`${$t(
                                                'contracts:comment'
                                            )}`"
                                            rows="1"
                                            auto-grow
                                            no-resize
                                            v-model="getContractModal.comment"
                                        >
                                        </v-textarea>
                                    </v-col>
                                </v-row>
                            </v-stepper-content>
                        </v-stepper-items>
                    </template>
                </v-stepper>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
    i18nOptions: { namespaces: ['global'] },
    data() {
        return {
            hideContacts: true,
            disabled: false,
            showMenu: false,
            step: 1,
            editable: true,
        }
    },
    methods: {
        ...mapActions([
            'fetchContactsInputs',
            'createRepresentative',
            'fetchRepresentativesInput',
        ]),
        ...mapMutations(['setContactsInput']),
        text: item => item.name + item.lastname,
        setContacts(search) {
            if (search.length >= 4) {
                this.setContactsInput({ search })
                this.fetchContactsInputs()
                this.hideContacts = false
            } else {
                this.getContactsInput.items = []
                this.hideContacts = true
            }
        },
        assignID() {
            if (
                this.getContractModal.contractor &&
                this.getContractModal.contractor._id
            ) {
                this.getContractModal.representative = null
                this.fetchRepresentativesInput({
                    id: this.getContractModal.contractor._id,
                })
            }
        },
        async additionRepresentative() {
            this.disabled = true
            let success = await this.createRepresentative({
                id: this.getContractModal.contractor._id,
            })
            if (success) {
                this.clearMiniModal()
                this.assignID()
            }

            this.disabled = false
        },
        clearMiniModal() {
            this.showMenu = false
        },
    },
    computed: {
        ...mapGetters([
            'getContractModal',
            'getContractErrors',
            'getRegistryDictionaries',
            'getContactsInput',
            'getRepresentativeInput',
            'getRepresentativeModal',
        ]),
    },
}
</script>
